module.exports = __webpack_public_path__ + "img/funda-palet.4eabfff2.jpg";